import Para from "@/atoms/text/Para";
import Image from "@/atoms/Image";
import Badge from "@/atoms/Badge";
import PropTypes from "prop-types";

export default function SubIntegrationTile({
  bgColor,
  badge,
  logo,
  title,
  content,
  className,
}) {
  return (
    <div
      className={`fx fx--sb fx--cv ps-r sub-integ-tile bc-${bgColor} ${className}`}
    >
      <Badge
        className="sub-integ-tile-badge"
        borderColor="grey"
        bgColor="white"
      >
        {badge}
      </Badge>
      {logo && (
        <Image
          fileName={logo}
          isBannerImg={false}
          fileFormat="png"
          desktopWidth="84"
          alt={title}
          className="fx--no-shrink"
        />
      )}
      <div className="ml-2">
        <Para
          desktopSize="lg"
          mobileSize="lg"
          className="text--mont mb-1 bold"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <Para mobileSize="md" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
      <style jsx>{`
        .sub-integ-tile {
          width: 100%;
          height: 100%;
          max-width: 460px;
          min-height: 138px;
          padding: 24px 20px;
          border: 2px solid #e2e2e7;
          border-radius: 8px;
        }
      `}</style>
    </div>
  );
}

SubIntegrationTile.defaultProps = {
  bgColor: "white",
  className: "",
};

SubIntegrationTile.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  badge: PropTypes.node,
  bgColor: PropTypes.string,
  logo: PropTypes.string,
  className: PropTypes.string,
};
